import CASBlock from "@components/Blocks/CASBlock/CASBlock";
import { CAS_CDP_PAYWALL_ID } from "@helper/getEnvVariables";
import useCasScript from "@hooks/useCasScript";
import useUserInfo from "@src/app/hooks/useUserInfo";

import { NormalGenGPaywal, NormalPaywall } from "./BannerHelper";
import { ArticleBannerProps } from "./RegistrationBanner";

export default function SubscriptionBanner({
  isInfiniteScrollArticle,
  pageNumber,
  isGenG = false,
}: ArticleBannerProps) {
  const { isScriptReady: isCasScriptReady } = useCasScript();
  const { userInfo } = useUserInfo();
  const userDisplayName = userInfo?.loginId;
  const casBlockProps = {
    key: `cas-${CAS_CDP_PAYWALL_ID}`,
    casId: CAS_CDP_PAYWALL_ID,
    ...(isInfiniteScrollArticle && { index: pageNumber }),
  };

  return (
    <div>
      <div className="relative">
        <div className="absolute bg-bg-primary/70 w-full h-[120px] bottom-8"></div>
        {isGenG
          ? NormalGenGPaywal(userDisplayName)
          : NormalPaywall(userDisplayName)}
      </div>
      {isCasScriptReady && <CASBlock {...casBlockProps} />}
    </div>
  );
}
